import { Link } from "react-router-dom";

/**
 * Gemeinsame Auth-Kopfzeile (Login + Registrierung), 1:1 an die App
 * (client/screens/AccountScreen.tsx, Standalone-Login-Gate) angelehnt:
 * App-Icon-Kachel + Wortmarke „COpter Pilot" + kontextabhängiger Untertitel,
 * darunter ein „Anmelden / Registrieren"-Umschalter im App-Stil.
 *
 * Der Umschalter wechselt zwischen den bestehenden Routen /login und /register
 * (Deep-Links bleiben erhalten); der aktive Tab spiegelt die aktuelle Route.
 */
export default function AuthHeader({ mode }: { mode: "login" | "register" }) {
  return (
    <div className="px-6 pt-12 pb-2 text-center">
      <div className="brand-tile" aria-hidden="true" />
      <h1 className="text-[28px] font-extrabold tracking-tight mt-5 text-[var(--color-app-text)]">
        COpter Pilot
      </h1>
      <p className="text-[14px] text-[var(--color-app-text-secondary)] mt-1">
        {mode === "login"
          ? "Melde dich an, um fortzufahren."
          : "Erstelle einen Account, um zu starten."}
      </p>

      <div className="auth-tabs" role="tablist" aria-label="Anmelden oder Registrieren">
        <Link
          to="/login"
          role="tab"
          aria-selected={mode === "login"}
          className={`auth-tab${mode === "login" ? " auth-tab-active" : ""}`}
          data-testid="tab-login"
        >
          Anmelden
        </Link>
        <Link
          to="/register"
          role="tab"
          aria-selected={mode === "register"}
          className={`auth-tab${mode === "register" ? " auth-tab-active" : ""}`}
          data-testid="tab-register"
        >
          Registrieren
        </Link>
      </div>
    </div>
  );
}
